import BenCardContent from "./ben-card-content";

export default BenCardContent;
